'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _MapMarker = require('./MapMarker');

var _MapMarker2 = _interopRequireDefault(_MapMarker);

var _i18n = require('../helpers/i18n');

var _i18n2 = _interopRequireDefault(_i18n);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var StaticMap = function (_Component) {
  _inherits(StaticMap, _Component);

  function StaticMap() {
    _classCallCheck(this, StaticMap);

    return _possibleConstructorReturn(this, (StaticMap.__proto__ || Object.getPrototypeOf(StaticMap)).apply(this, arguments));
  }

  _createClass(StaticMap, [{
    key: 'render',
    value: function render() {
      var params = {
        center: this.props.latitude + ',' + this.props.longitude,
        key: this.props.apiKey,
        zoom: this.props.zoom,
        scale: this.props.scale,
        size: this.props.width + 'x' + this.props.height,
        maptype: 'roadmap'
      };
      var paramsArray = [];
      Object.keys(params).map(function (param) {
        return paramsArray.push(encodeURIComponent(param) + '=' + encodeURIComponent(params[param]));
      });
      var paramsString = paramsArray.join('&');
      var latlong = this.props.latitude + ',' + this.props.longitude;
      var directionsURL = 'http://www.google.com/maps/place/' + latlong + '/@' + latlong + ',15z';
      var style = { paddingBottom: this.props.height / this.props.width * 100 + '%' };

      return _react2.default.createElement(
        'div',
        { className: 'StaticMap' },
        _react2.default.createElement(
          'a',
          { target: '_blank', rel: 'noopener noreferrer', href: directionsURL, style: style },
          _react2.default.createElement('img', { src: 'https://maps.googleapis.com/maps/api/staticmap?' + paramsString, alt: (0, _i18n2.default)('venueMap') }),
          _react2.default.createElement(_MapMarker2.default, null)
        )
      );
    }
  }]);

  return StaticMap;
}(_react.Component);

StaticMap.propTypes = {
  /** The Google Static Maps API key. */
  apiKey: _propTypes2.default.string.isRequired,
  /** The height of the map. */
  height: _propTypes2.default.number,
  /** The latitude of the map marker. */
  latitude: _propTypes2.default.string.isRequired,
  /** The longitude of the map marker. */
  longitude: _propTypes2.default.string.isRequired,
  /** The scale of the map. */
  scale: _propTypes2.default.number,
  /** The width of the map. */
  width: _propTypes2.default.number,
  /** The zoom level of the map. */
  zoom: _propTypes2.default.number
};
StaticMap.defaultProps = {
  height: 170,
  scale: 2,
  width: 350,
  zoom: 14
};
exports.default = StaticMap;
StaticMap.__docgenInfo = {
  'description': '',
  'methods': [],
  'displayName': 'StaticMap',
  'props': {
    'height': {
      'defaultValue': {
        'value': '170',
        'computed': false
      },
      'type': {
        'name': 'number'
      },
      'required': false,
      'description': 'The height of the map.'
    },
    'scale': {
      'defaultValue': {
        'value': '2',
        'computed': false
      },
      'type': {
        'name': 'number'
      },
      'required': false,
      'description': 'The scale of the map.'
    },
    'width': {
      'defaultValue': {
        'value': '350',
        'computed': false
      },
      'type': {
        'name': 'number'
      },
      'required': false,
      'description': 'The width of the map.'
    },
    'zoom': {
      'defaultValue': {
        'value': '14',
        'computed': false
      },
      'type': {
        'name': 'number'
      },
      'required': false,
      'description': 'The zoom level of the map.'
    },
    'apiKey': {
      'type': {
        'name': 'string'
      },
      'required': true,
      'description': 'The Google Static Maps API key.'
    },
    'latitude': {
      'type': {
        'name': 'string'
      },
      'required': true,
      'description': 'The latitude of the map marker.'
    },
    'longitude': {
      'type': {
        'name': 'string'
      },
      'required': true,
      'description': 'The longitude of the map marker.'
    }
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/caligram-react/dist/components/StaticMap.js
// module id = 192
// module chunks = 0